<script>
    import {initializeGsapAnimation} from '../../utils.js';
    import MobileFooter from '../../reusableitems/mobileFooter.svelte';
    import {onMount} from 'svelte';
    import Mobilebtn from '../mobilebtn.svelte';

    let main;
    let imgg;
    let div1;
    let div2;
    let div3;
    let div4;
    onMount(onStart);
    /**
     */
    function onStart() {
        initializeGsapAnimation(
            main,
            imgg,
            [
                {scale: '1.7', left: '18vw', duration: 1},
                {scale: '1.3', left: '2vw', duration: 1},
            ],
            3,
        );
        initializeGsapAnimation(
            main,
            div1,
            [
                {translateY: '-16.682vw', duration: 1},
                {translateY: '-16.682vw', duration: 1},
            ],
            3,
        );
        initializeGsapAnimation(
            main,
            div2,
            [
                {translateY: '-16.682vw', duration: 1},
                {translateY: '-16.682vw', duration: 1},
            ],
            3,
        );
        initializeGsapAnimation(
            main,
            div3,
            [
                {translateY: '-15.187vw', duration: 1},
                {translateY: '-15.187vw', duration: 1},
            ],
            3,
        );
        // initializeGsapAnimation(
        //     main,
        //     div4,
        //     [
        //         {translateX: 0, translateY: '-7vw', duration: 1},
        //         {translateX: 0, translateY: '-7vw', duration: 1},
        //     ],
        //     3,
        // );
    }
</script>

<section>
    <div class="main" bind:this={main}>
        <!-- svelte-ignore a11y-img-redundant-alt -->
        <div class="bg-img" bind:this={imgg}>
            <img
                src="images/Gamer/OpusAmbassador-33.png"
                alt="Background Image"
                width="100%"
                height="100%"
            />
        </div>
        <div class="container">
            <div class="first" bind:this={div1}><p>CASUAL</p></div>

            <div class="second" bind:this={div2}><p>GAMERS</p></div>
            <div class="third" bind:this={div3}>
                <p>
                    Escape into the dynamic world created by players like you,
                    tailored for injecting fun into a busy life. We’re building
                    the future of casual gaming narrated and produced by players
                    like you. Step into it.
                </p>
            </div>
        </div>
        <div class="fourth" bind:this={div4}>
            <!-- <button>Join Games Governance Council (Casual Seat)</button> -->
            <Mobilebtn bgcolor="#615bff" width="60.748vw" height="10.047vw" state='Games'/>
        </div>
        <div class="footer">
            <MobileFooter />
        </div>
    </div>
</section>

<style>
    .bg-img {
        filter: drop-shadow(10px 20px 64px rgba(0, 0, 0, 0.3));
        height: 70.518vh;
        position: absolute;
        top: 0vw;
        width: 100vw;
        left: 2vw;
        scale: 1.3;
    }
    .first {
        width: 70.561vw;
        height: 17.523vw;
        margin-bottom: -3.271vw;
        margin-left: 4.206vw;
        transform: translateY(19.346vw);
    }
    .first p {
        margin: 0;
        font-family: "Orbitron";
        font-style: normal;
        font-weight: 700;
        font-size: 14.019vw;
        line-height: 17.523vw;
        letter-spacing: 0.02em;
        color: #615bff;
    }
    .second {
        margin-left: 11.215vw;
        width: 71.729vw;
        height: 17.523vw;
        margin-bottom: 5.14vw;
        transform: translateY(19.346vw);
    }
    .second p {
        margin: 0;
        font-family: "Orbitron";
        font-style: normal;
        font-weight: 700;
        font-size: 14.019vw;
        line-height: 17.523vw;
        letter-spacing: 0.02em;
        -webkit-text-stroke: 0.234vw black;
        color: transparent;
    }
    .third {
        width: 76.636vw;
        height: 19.86vw;
        margin-bottom: 11.449vw;
        margin-left: 6.308vw;
        transform: translateY(22.5vw);
    }

    .third p {
        font-family: "Orbitron";
        font-style: normal;
        font-weight: 400;
        font-size: 2.804vw;
        letter-spacing: 0.06em;
        color: #000000;
    }

    .fourth {
        position: absolute;
        left: 0;
        right: 0;
        bottom: 11.389vh;
        /* padding-top: 184vw; */
        box-sizing: border-box;
    }
    /* .fourth button {
        margin: auto;
        border: none;
        width: 60.748vw;
        height: 10.047vw;
        background-color: #615bff;
        font-family: "Orbitron";
        font-style: normal;
        font-weight: 700;
        font-size: 2.804vw;
        line-height: 3.505vw;
        letter-spacing: 0.02em;
        color: #ffffff;
    } */
    .main {
        width: 100%;
        /* height: max(216.355vw, 100vh); */
        height: 100vh;
        position: relative;
        overflow: hidden;
    }
    .container {
        width: 100%;
        position: absolute;
        /* bottom: max(43.333vh, 25vw); */
        /* bottom: 43.33vh; */
        top: 50.54vh;
    }
    .footer {
        position: absolute;
        bottom: 0vw;
        width: 100%;
    }
</style>
